import React, { useEffect, useRef, useState } from "react";
import MainPagetitle from "../../layouts/MainPagetitle";
import LeadsCenteredModal from "./Leads/LeadsCenteredModal";
import ActiveEmiInfo from "./DashboardHelpers/ActiveEmiInfo/ActiveEmiInfo";

const CollectionsHome = (props) => {
  const infoForm = useRef(null);
  const [overallPortfolioData, setOverallPortfolioData] = useState({});
  const [timeline, setTimeline] = useState("TODAY");

  const [activitiesData, setActivitiesData] = useState({});
  const [overduePortfolioData, setOverduePortfolioData] = useState({});

  const overdueCardData = [
    {
      title: "0-30",
      count: overduePortfolioData?.last0030dayOverdueCount,
      amount: overduePortfolioData?.last0030dayOverdueAmt,
      path: `/app/portfolioinfo?cardname=overdue30&path=collectionshome`,
    },
    {
      title: "30-60",
      count: overduePortfolioData?.last6030dayOverdueCount,
      amount: overduePortfolioData?.last6030dayOverdueAmt,
      path: `/app/portfolioinfo?cardname=overdue60&path=collectionshome`,
    },
    {
      title: "60-90",
      count: overduePortfolioData?.last6090dayOverdueCount,
      amount: overduePortfolioData?.last6090dayOverdueAmt,
      path: `/app/portfolioinfo?cardname=overdue90&path=collectionshome`,
    },
    {
      title: "90-180",
      count: overduePortfolioData?.last90180dayOverdueCount,
      amount: overduePortfolioData?.last90180dayOverdueAmt,
      path: `/app/portfolioinfo?cardname=overdue180&path=collectionshome`,
    },
    {
      title: "180+",
      count: overduePortfolioData?.last180day$OverdueCount,
      amount: overduePortfolioData?.last180day$OverdueAmt,
      path: `/app/portfolioinfo?cardname=overdue180Plus&path=collectionshome`,
    },
  ];

  // OVERALL PORTFOLIO
  const getRevenueTotalCollections = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetRevenueTotalCollections(data, payload).then((res) => {
      setOverallPortfolioData((prevState) => ({
        ...prevState,
        totalCollection: res,
      }));
    });
  };
  const getRevenuePrinciple = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetRevenuePrinciple(data, payload).then((res) => {
      setOverallPortfolioData((prevState) => ({
        ...prevState,
        revenuePrinciple: res,
      }));
    });
  };
  const getRevenueInterest = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetRevenueInterest(data, payload).then((res) => {
      setOverallPortfolioData((prevState) => ({
        ...prevState,
        revenueInterest: res,
      }));
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setOverallPortfolioData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      ...Object.except(data, ["timeline"]),
    };
    getRevenueTotalCollections(queryData, "CUSTOM");
    getRevenuePrinciple(queryData, "CUSTOM");
    getRevenueInterest(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    hideInputs(inputs);
    getRevenueTotalCollections({}, "TODAY");
    getRevenuePrinciple({}, "TODAY");
    getRevenueInterest({}, "TODAY");
  };

  // ACTIVITIES
  const getActivitiesOverdueYesterday = () => {
    props.apis.apiGetActivitiesOverdueYesterday().then((res) => {
      console.log({ res });
      setActivitiesData((prevState) => ({
        ...prevState,
        activitiesOverdueYesterday: res,
      }));
    });
  };

  const getActivitiesCollectionsYesterday = () => {
    props.apis.apiGetActivitiesCollectionsYesterday().then((res) => {
      console.log({ res });
      setActivitiesData((prevState) => ({
        ...prevState,
        activitiesCollectionsYesterday: res,
      }));
    });
  };

  const getActivitiesOverdueToday = () => {
    props.apis.apiGetActivitiesOverdueToday().then((res) => {
      console.log({ res });
      setActivitiesData((prevState) => ({
        ...prevState,
        activitiesOverdueToday: res,
      }));
    });
  };

  const getActivitiesCollectionsToday = () => {
    props.apis.apiGetActivitiesCollectionsToday().then((res) => {
      console.log({ res });
      setActivitiesData((prevState) => ({
        ...prevState,
        activitiesCollectionsToday: res,
      }));
    });
  };

  // OVERDUE PORTFOLIO
  const GetDashboardAdminOverduePortfolio = () => {
    props.apis.apiGetDashboardAdminOverduePortfolio().then((res) => {
      console.log({ res });
      setOverduePortfolioData(res);
    });
  };

  useEffect(() => {
    // OVERALL PORTFOLIO
    getRevenueTotalCollections();
    getRevenuePrinciple();
    getRevenueInterest();

    // ACTIVITIES
    getActivitiesOverdueYesterday();
    getActivitiesCollectionsYesterday();
    getActivitiesOverdueToday();
    getActivitiesCollectionsToday();

    // OVERDUE PORTFOLIO
    GetDashboardAdminOverduePortfolio();
  }, [timeline]);

  // ----------------------------------------------------------------
  const changePasswordModalRef = useRef(0);
  const [popupChangePasswordFields, setPopupChangePasswordFields] = useState(
    {}
  );
  const [changepasswordData, setChangepasswordData] = useState({});
  const [changepasswordFields, setChangepasswordFields] = useState([
    {
      label: "Old Password",
      name: "oldPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "New Password ",
      name: "newPassword",
      type: "password",
      customcolspan: "12",
    },
    {
      label: "Confirm Password",
      name: "confirmPassword",
      type: "password",
      customcolspan: "12",
    },
  ]);

  // HANDLE CHANGE PASSWORD MODAL
  const openChangePasswordmodal = () => {
    changePasswordModalRef.current.click();
  };

  const closeChangePasswordmodal = () => {
    document.querySelector("#changepasswordModal #bsmodalclose").click();
    setChangepasswordData({});
    setPopupChangePasswordFields({});
  };

  const addChangepasswordData = () => {
    let fields = (changepasswordFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);
    setPopupChangePasswordFields(fields);
    setChangepasswordData(formdata);
    openChangePasswordmodal();
  };

  const handleChangePasswordSubmit = (e, data) => {
    console.log({ handleChangePasswordSubmit: data });
    if (data.newPassword !== data.confirmPassword) {
      swal2.fire({
        title: "Password and Confirm Password does not match",
        icon: "warning",
        iconColor: "#BB1766",
        timer: 4000,
      });
    } else {
      let payload = {
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
      };

      props.apis.apiPasswordReset(payload).then((res) => {
        console.log({ apiPasswordReset: res });
        if (res.status === 200) {
          swal2
            .fire({
              title:
                "Password changed successfully, Please re-login with new password",
              icon: "success",
              iconColor: "#BB1766",
            })
            .then((result) => {
              if (result.isConfirmed) {
                closeChangePasswordmodal();
                props?.apis?.applogout();
                props?.navigate("/open/login");
              }
            });
        }
      });
    }
  };

  // ------------------
  useEffect(() => {
    const { isPasswordUpdated, role } = props?.$store?.user;
    if (!isPasswordUpdated & (role !== _enum.PERSONAS.admin)) {
      addChangepasswordData();
    }
  }, []);
  props.$setNode({
    props,
    overallPortfolioData,
  });

  return (
    <>
      <MainPagetitle
        mainTitle="Dashboard"
        pageTitle="Dashboard"
        parentTitle="Collections Home"
        pageIcon={imagepaths.DashboardActive}
      />

      <div className="container-fluid">
        <h2 className="fs-4 mb-3">Overall Portfolio</h2>

        <div className="metrics_card_container mb-4">
          <div className="leads_detail_select_box">
            <AppForm
              ref={infoForm}
              onSubmit={(...args) => onSearch(...args)}
              className="row justify-content-end"
            >
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2"
                id="column-timeline"
              >
                <AppInputFocus
                  type="select"
                  name="timeline"
                  label="Time Line"
                  options={_enum.OVERALL_DETAIL}
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Time Line"
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="column-start_date"
              >
                <AppInputFocus
                  type="date"
                  name="start_date"
                  label="Start Date"
                  placeholder="Start Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="column-end_date"
              >
                <AppInputFocus
                  type="date"
                  name="end_date"
                  label="End Date"
                  placeholder="End Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="column-search_btn"
              >
                <button type="submit" className="btn search_btn white_variant">
                  <i className="fa fa-search"></i>
                </button>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="column-reset_btn"
              >
                <button
                  type="button"
                  className="btn search_btn white_variant"
                  onClick={(...args) => resetSearchForm(...args)}
                >
                  <i className="fa-solid fa-filter-circle-xmark"></i>
                </button>
              </div>
            </AppForm>
          </div>
          <div className="row g-4 metrics_card_row">
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 metrics_card">
              <div className="col_left">
                <img
                  src={imagepaths.overallBookImg}
                  className="lead_card_img"
                  alt="card icon"
                />
              </div>
              <div className="col_right">
                <h5 className="card-title">Total Collections</h5>
                <div className="bottom_content">
                  <p className="card-text">
                    <span className="me-2">Total :</span>
                    <span>
                      {overallPortfolioData?.totalCollection?.repaymentCount ||
                        0}
                    </span>
                  </p>
                  <p className="card-text">
                    <span className="me-2">Amount :</span>
                    <span>
                      {overallPortfolioData?.totalCollection?.repaymentAmt?.cur() ||
                        0}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 metrics_card">
              <div className="col_left">
                <img
                  src={imagepaths.dollarCheckImg}
                  className="lead_card_img"
                  alt="card icon"
                />
              </div>
              <div className="col_right">
                <h5 className="card-title">Principal Amount Collected</h5>
                <div className="bottom_content">
                  <p className="card-text">
                    <span className="me-2">Total :</span>
                    <span>
                      {overallPortfolioData?.revenuePrinciple?.principleCount ||
                        0}
                    </span>
                  </p>
                  <p className="card-text">
                    <span className="me-2">Amount :</span>
                    <span>
                      {overallPortfolioData?.revenuePrinciple?.principleAmt?.cur() ||
                        0}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-4 metrics_card">
              <div className="col_left">
                <img
                  src={imagepaths.dollarCloseImg}
                  className="lead_card_img"
                  alt="card icon"
                />
              </div>
              <div className="col_right">
                <h5 className="card-title">Interest Amount Collected</h5>
                <div className="bottom_content">
                  <p className="card-text">
                    <span className="me-2">Total :</span>
                    <span>
                      {overallPortfolioData?.revenueInterest?.interestCount ||
                        0}
                    </span>
                  </p>
                  <p className="card-text">
                    <span className="me-2">Amount :</span>
                    <span>
                      {overallPortfolioData?.revenueInterest?.interestAmt?.cur() ||
                        0}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2 className="fs-4 mt-4">Active EMI Info.</h2>
        <ActiveEmiInfo />

        <h2 className="fs-4 mt-4 mb-5">Activities</h2>
        <div className="row g-5 g-lg-4">
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="card activity_card">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 position-relative">
                  <div
                    className="dashboard_card application_card left"
                    onClick={(...args) =>
                      navigate(
                        `/app/portfolioinfo?cardname=overdueYesterday&path=collectionshome`
                      )
                    }
                  >
                    <div className="card-body">
                      <div className="icon_container">
                        <div className="icon_label">
                          <p className="m-0">Yesterday</p>
                        </div>
                        <div className="icon">
                          <img
                            src={imagepaths.dollarBagInHandIcon}
                            alt="icon image"
                          />
                        </div>
                      </div>
                      <div className="content">
                        <p className="icon_title">Due Yesterday</p>
                        <p className="count">
                          {
                            activitiesData?.activitiesOverdueYesterday
                              ?.overdueCount
                          }
                        </p>
                        <p className="card_label">
                          Amount :
                          <span className="primary-red ms-1">
                            {activitiesData?.activitiesOverdueYesterday?.overdueAmt?.cur()}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="verticle_line d-none d-md-block"></div>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <div
                    className="dashboard_card application_card right"
                    onClick={(...args) =>
                      navigate(
                        `/app/portfolioinfo?cardname=collectionsYesterday&tablename=collections&path=collectionshome`
                      )
                    }
                  >
                    <div className="card-body">
                      <div className="icon_container">
                        <div className="icon">
                          <img
                            src={imagepaths.dollarCollectionIcon}
                            alt="icon image"
                          />
                        </div>
                      </div>
                      <div className="content">
                        <p className="icon_title">Collections</p>
                        <p className="count">
                          {
                            activitiesData?.activitiesCollectionsYesterday
                              ?.repaymentCount
                          }
                        </p>
                        <p className="card_label">
                          Amount :
                          <span className="primary-red ms-1">
                            {activitiesData?.activitiesCollectionsYesterday?.repaymentAmt?.cur()}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border_bottom_line"></div>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <div className="card activity_card">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6 position-relative">
                  <div
                    className="dashboard_card application_card left"
                    onClick={(...args) =>
                      navigate(
                        `/app/portfolioinfo?cardname=overdueToday&path=collectionshome`
                      )
                    }
                  >
                    <div className="card-body">
                      <div className="icon_container">
                        <div className="icon_label">
                          <p className="m-0">Today</p>
                        </div>
                        <div className="icon">
                          <img
                            src={imagepaths.dollarBagInHandIcon}
                            alt="icon image"
                          />
                        </div>
                      </div>
                      <div className="content">
                        <p className="icon_title">Due Today</p>
                        <p className="count">
                          {activitiesData?.activitiesOverdueToday?.overdueCount}
                        </p>
                        <p className="card_label">
                          Amount :
                          <span className="primary-red ms-1">
                            {activitiesData?.activitiesOverdueToday?.overdueAmt?.cur()}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="verticle_line d-none d-md-block"></div>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <div
                    className="dashboard_card application_card right"
                    onClick={(...args) =>
                      navigate(
                        `/app/portfolioinfo?cardname=collectionsToday&tablename=collections&path=collectionshome`
                      )
                    }
                  >
                    <div className="card-body">
                      <div className="icon_container">
                        <div className="icon">
                          <img
                            src={imagepaths.dollarCollectionIcon}
                            alt="icon image"
                          />
                        </div>
                      </div>
                      <div className="content">
                        <p className="icon_title">Collections</p>
                        <p className="count">
                          {
                            activitiesData?.activitiesCollectionsToday
                              ?.repaymentCount
                          }
                        </p>
                        <p className="card_label">
                          Amount :
                          <span className="primary-red ms-1">
                            {activitiesData?.activitiesCollectionsToday?.repaymentAmt?.cur()}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border_bottom_line"></div>
            </div>
          </div>
        </div>

        <h2 className="fs-4 mt-4 mb-3">Over Due Portfolio</h2>
        <div className="row">
          {overdueCardData &&
            overdueCardData.map((data) => {
              return (
                <div className="col-xl-3 col-sm-6">
                  <div
                    className="card dashboard_card overdue_card"
                    onClick={(...args) => navigate(data?.path)}
                  >
                    <div className="border_bottom_line"></div>
                    <div className="card-body">
                      <div className="icon">
                        <p className="count_text">{data.title}</p>
                        <p className="count_label">Days</p>
                      </div>
                      <div className="content">
                        <p className="count">{data.count}</p>
                        <p className="card_label">
                          Amount :
                          <span className="primary-red ms-1">
                            {data?.amount?.cur()}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* below button hidden on UI */}
      <button
        className="btn btn-sm btn-outline-secondary d-none"
        onClick={(e) => addChangepasswordData(e)}
        ref={changePasswordModalRef}
        data-bs-toggle="modal"
        data-bs-target="#changepasswordModal"
      >
        <span>Change Password</span>
      </button>

      <LeadsCenteredModal
        id="changepasswordModal"
        title="Change Password"
        submitText="Chage Password"
        hidecancelbtn={true}
        data={changepasswordData}
        fields={popupChangePasswordFields}
        onSubmit={(...args) => handleChangePasswordSubmit(...args)}
        modaltype="centeredmodal"
        onClose={() => closeChangePasswordmodal()}
      />
    </>
  );
};
export default constore(CollectionsHome);
